import { DITTO_THREAD_URL, NOSTR_101_URL } from '@/lib/constants';
import { Bitcoin, ExternalLink } from 'lucide-react';

export function Footer() {
  return (
    <footer className="relative border-t border-border/30">
      <div className="absolute inset-0 bg-gradient-to-t from-primary/[0.02] to-transparent" />

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
        <div className="flex flex-col items-center text-center space-y-6">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-lg bg-primary/10 flex items-center justify-center">
              <Bitcoin className="w-4 h-4 text-primary" />
            </div>
            <span className="font-display text-base font-bold tracking-tight">
              <span className="text-bitcoin-gradient">MAXI</span>
              <span className="text-foreground"> MADNESS</span>
            </span>
          </div>

          {/* Links */}
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm">
            <a
              href={DITTO_THREAD_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-foreground/70 hover:text-primary transition-colors duration-200 flex items-center gap-1.5"
            >
              View Original Thread
              <ExternalLink className="w-3 h-3" />
            </a>
            <a
              href="https://bugle.news"
              target="_blank"
              rel="noopener noreferrer"
              className="text-foreground/70 hover:text-primary transition-colors duration-200 flex items-center gap-1.5"
            >
              Bugle.News
              <ExternalLink className="w-3 h-3" />
            </a>
            <a
              href={NOSTR_101_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-foreground/70 hover:text-primary transition-colors duration-200 flex items-center gap-1.5"
            >
              What is Nostr?
              <ExternalLink className="w-3 h-3" />
            </a>
          </div>

          {/* Bottom line */}
          <div className="pt-4 border-t border-border/20 w-full max-w-sm">
            <p className="text-xs text-muted-foreground/60">
              Votes are Nostr events, permanently stored on the protocol.{' '}
              <a
                href="https://shakespeare.diy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-foreground/40 hover:text-primary/60 transition-colors"
              >
                Vibed with Shakespeare
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
